import { render, staticRenderFns } from "./SectionDevContact.vue?vue&type=template&id=0569bf4b&scoped=true"
import script from "./SectionDevContact.vue?vue&type=script&lang=ts"
export * from "./SectionDevContact.vue?vue&type=script&lang=ts"
import style0 from "./SectionDevContact.vue?vue&type=style&index=0&id=0569bf4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0569bf4b",
  null
  
)

export default component.exports